import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, URL } from "./Constants";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      // const token = getToken();
      const token = localStorage.getItem("token");
      headers.set("Authorization", "Bearer " + token);
      // headers.set("Content-Type", "multipart/form-data");
      // headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
    },
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: [],
  endpoints: (builder) => ({
    // LOGIN
    login: builder.mutation({
      query: (payload) => ({
        url: URL.LOGIN,
        body: payload,
        method: "POST",
      }),
    }),

    // LOGOUT
    logout: builder.query({
      query: () => URL.LOGOUT,
    }),

    dashboard: builder.query({
      query: () => URL.DASHBOARD,
    }),

    roleCreate: builder.query({
      query: () => URL.ROLE + "/create",
    }),

    roleList: builder.query({
      query: (params) => URL.ROLE + params,
    }),

    roleAdd: builder.mutation({
      query: (payload) => ({
        url: URL.ROLE,
        body: payload,
        method: "POST",
      }),
    }),

    roleEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.ROLE + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    roleView: builder.query({
      query: (id) => URL.ROLE + "/" + id + "/edit",
    }),

    roleStatus: builder.query({
      query: (id) => URL.ROLE + "/status/" + id,
    }),

    adminList: builder.query({
      query: (params) => URL.ADMIN + params,
    }),

    adminAdd: builder.mutation({
      query: (payload) => ({
        url: URL.ADMIN,
        body: payload,
        method: "POST",
      }),
    }),

    adminEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.ADMIN + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    adminView: builder.query({
      query: (id) => URL.ADMIN + "/" + id + "/edit",
    }),

    adminStatus: builder.query({
      query: (id) => URL.ADMIN + "/status/" + id,
    }),

    adminRole: builder.query({
      query: () => URL.ADMIN + "/create",
    }),

    stateList: builder.query({
      query: (params) => URL.STATES + params,
    }),

    stateAdd: builder.mutation({
      query: (payload) => ({
        url: URL.STATES,
        body: payload,
        method: "POST",
      }),
    }),

    stateEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.STATES + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    stateView: builder.query({
      query: (id) => URL.STATES + "/" + id + "/edit",
    }),

    cityList: builder.query({
      query: (params) => URL.CITY + params,
    }),

    cityAdd: builder.mutation({
      query: (payload) => ({
        url: URL.CITY,
        body: payload,
        method: "POST",
      }),
    }),

    cityEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.CITY + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    cityView: builder.query({
      query: (id) => URL.CITY + "/" + id + "/edit",
    }),

    getState: builder.query({
      query: () => URL.CITY + "/create",
    }),

    getCityLocation: builder.query({
      query: (id) => URL.CITY + "/location/" + id,
    }),

    locationList: builder.query({
      query: (params) => URL.LOCATION + params,
    }),

    locationAdd: builder.mutation({
      query: (payload) => ({
        url: URL.LOCATION,
        body: payload,
        method: "POST",
      }),
    }),

    locationEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.LOCATION + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    locationView: builder.query({
      query: (id) => URL.LOCATION + "/" + id,
    }),

    getlocation: builder.query({
      query: () => URL.LOCATION + "/create",
    }),

    getStateCities: builder.query({
      query: (id) => URL.STATES + "/cities/" + id,
    }),

    usersList: builder.query({
      query: (params) => URL.USERS + params,
    }),

    userStatus: builder.query({
      query: (id) => URL.USER + "/status/" + id,
    }),

    userBookings: builder.query({
      query: ({ id, params }) => URL.USER + "/bookings/" + id + params,
    }),

    userDetails: builder.query({
      query: (id) => URL.USER + "/details/" + id,
    }),

    userWalletTransactions: builder.query({
      query: ({ id, params }) =>
        URL.USER + "/wallet-transactions/" + id + params,
    }),

    bookingDetails: builder.query({
      query: (id) => URL.BOOKING_DETAILS + "/" + id,
    }),

    requestPropertyList: builder.query({
      query: (params) => URL.REQUEST_PROPERTY + params,
    }),

    requestPropertyStatus: builder.query({
      query: (id) => URL.PROPERTY_STATUS + id,
    }),

    propertyCreate: builder.query({
      query: () => URL.PROPERTY_CREATE,
    }),

    propertyAdd: builder.mutation({
      query: (payload) => ({
        url: URL.PROPERTY,
        body: payload,
        method: "POST",
      }),
    }),

    propertyUpdate: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.PROPERTY + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    propertyImgUpdate: builder.mutation({
      query: (payload) => ({
        url: URL.UPDATE_PROPERTY,
        body: payload,
        method: "POST",
      }),
    }),

    propertyView: builder.query({
      query: (id) => URL.PROPERTY + "/" + id,
    }),

    propertyShow: builder.query({
      query: (id) => URL.PROPERTY + "/" + id + "/edit",
    }),

    propertyList: builder.query({
      query: (params) => URL.PROPERTY + params,
    }),

    propertyStatus: builder.query({
      query: (id) => URL.PROPERTY + "/status/" + id,
    }),

    propertyDelete: builder.query({
      query: (id) => URL.PROPERTY + "/image/delete/" + id,
    }),

    // Full Block
    fullBlockList: builder.query({
      query: (params) => URL.FULL_BLOCK + params,
    }),

    blockProperty: builder.mutation({
      query: (payload) => ({
        url: URL.BLOCK_PROPERTY,
        body: payload,
        method: "POST",
      }),
    }),

    propertyBookings: builder.query({
      query: ({ id, params }) => URL.PROPERTY + "/bookings/" + id + params,
    }),

    propertyTransactions: builder.query({
      query: ({ id, params }) => URL.PROPERTY + "-transactions/" + id + params,
    }),

    propertyService: builder.query({
      query: ({ id, type }) =>
        "/show/" + URL.PROPERTY + "/service/" + type + "/" + id,
    }),

    foodPackageAdd: builder.mutation({
      query: ({ id, payload }) => ({
        url: "add/" + URL.FOOD_PACKAGE + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    foodPackageEdit: builder.mutation({
      query: ({ id, payload }) => ({
        url: "edit/" + URL.FOOD_PACKAGE + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    foodPackageShow: builder.query({
      query: (id) => "show/" + URL.FOOD_PACKAGE + "/" + id,
    }),

    foodPackageRemove: builder.query({
      query: (id) => URL.FOOD_PACKAGE_REMOVE + id,
    }),

    foodPackageDelete: builder.query({
      query: (id) => URL.FOOD_PACKAGE_DELETE + id,
    }),

    propertyServiceAdd: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.ADD_PROPERTY_SERVICE + id,
        body: payload,
        method: "POST",
      }),
    }),

    propertyServiceEdit: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.EDIT_PROPERTY_SERVICE + id,
        body: payload,
        method: "POST",
      }),
    }),

    propertyServiceView: builder.query({
      query: ({ id, type }) => URL.VIEW_PROPERTY_SERVICE + `${type}/` + id,
    }),

    servicesCreate: builder.query({
      query: () => URL.SERVICE_CREATE,
    }),

    listPhases: builder.query({
      query: (id) => URL.LIST_PHASES + id,
    }),

    showRoom: builder.query({
      query: (id) => URL.SHOW_ROOM + id,
    }),

    blockVillaPhase: builder.mutation({
      query: (payload) => ({
        url: URL.BLOCK_VILLA_PHASE,
        body: payload,
        method: "POST",
      }),
    }),

    roomServiceAdd: builder.mutation({
      query: ({ id, type, payload }) => ({
        url: URL.ROOM_SERVICE + `/add/${id}/${type}`,
        body: payload,
        method: "POST",
      }),
    }),

    roomServiceEdit: builder.mutation({
      query: ({ id, type, payload }) => ({
        url: URL.ROOM_SERVICE + `/edit/${id}/${type}`,
        body: payload,
        method: "POST",
      }),
    }),

    roomBookingCreate: builder.query({
      query: () => URL.ROOM_BOOKING_CREATE,
    }),

    roomAdd: builder.mutation({
      query: ({ id, type, payload }) => ({
        url: URL.ADD_ROOM + `${id}/${type}`,
        body: payload,
        method: "POST",
      }),
    }),

    roomEdit: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.EDIT_ROOM + `${id}`,
        body: payload,
        method: "POST",
      }),
    }),

    roomBookingSlot: builder.query({
      query: (param) => URL.ROOM_BOOKING_SLOT + param,
    }),

    editTimeSlot: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.EDIT_TIME_SLOT + `${id}`,
        body: payload,
        method: "POST",
      }),
    }),

    addTimeSlot: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.ADD_TIME_SLOT + `${id}`,
        body: payload,
        method: "POST",
      }),
    }),

    deleteRoomImg: builder.query({
      query: (id) => URL.DELETE_ROOM_IMAGE + id,
    }),

    blockJwDo: builder.mutation({
      query: (payload) => ({
        url: URL.BLOCK_JW_DO,
        body: payload,
        method: "POST",
      }),
    }),

    showGetToGether: builder.query({
      query: (id) => URL.SHOW_GET_TO_GETHER + id,
    }),

    listRooms: builder.query({
      query: (id) => URL.LIST_ROOM + id,
    }),

    blockRooms: builder.mutation({
      query: (payload) => ({
        url: URL.BLOCK_ROOMS,
        body: payload,
        method: "POST",
      }),
    }),

    ownerAllList: builder.query({
      query: (parmas) => URL.OWNER + parmas,
    }),

    ownerList: builder.query({
      query: (id) => URL.OWNER + "/" + id,
    }),

    ownerStatus: builder.query({
      query: (id) => URL.OWNER + "/status/" + id,
    }),

    ownerCreate: builder.mutation({
      query: (payload) => ({
        url: URL.OWNER,
        body: payload,
        method: "POST",
      }),
    }),

    ownerEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.OWNER + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    propertiesOwnerList: builder.query({
      query: (parmas) => URL.PROPERTY_OWNER + parmas,
    }),

    ownerTransactionsList: builder.query({
      query: (parmas) => URL.OWNER_TRASACTION + parmas,
    }),

    blockList: builder.query({
      query: (parmas) => URL.BLOCK_LIST + parmas,
    }),

    listPhasesRooms: builder.query({
      query: (parmas) => URL.LIST_PHASE_ROOMS + parmas,
    }),

    blockVillaRooms: builder.mutation({
      query: (payload) => ({
        url: URL.BLOCK_VILLA_ROOMS,
        body: payload,
        method: "POST",
      }),
    }),

    unBlockPropery: builder.mutation({
      query: (payload) => ({
        url: URL.UNBLOCK_PROPERTY,
        body: payload,
        method: "POST",
      }),
    }),

    unBlockRoom: builder.mutation({
      query: (payload) => ({
        url: URL.UNBLOCK_ROOM,
        body: payload,
        method: "POST",
      }),
    }),

    receptionistList: builder.query({
      query: (parmas) => URL.RECEPTIONIST + parmas,
    }),

    receptionistStatus: builder.query({
      query: (id) => URL.RECEPTIONIST + "/status/" + id,
    }),

    receptionistMaster: builder.query({
      query: () => URL.RECEPTIONIST + "/create",
    }),

    receptionistCreate: builder.mutation({
      query: (payload) => ({
        url: URL.RECEPTIONIST,
        body: payload,
        method: "POST",
      }),
    }),

    receptionistEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.RECEPTIONIST + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    receptionistView: builder.query({
      query: (id) => URL.RECEPTIONIST + "/" + id,
    }),

    ownerPropertiesList: builder.query({
      query: (id) => URL.OWNER + "/properties/" + id,
    }),

    mmcList: builder.query({
      query: (parmas) => URL.MMC + parmas,
    }),

    mmcStatus: builder.query({
      query: (id) => URL.MMC + "/status/" + id,
    }),

    mccCreate: builder.mutation({
      query: (payload) => ({
        url: URL.MMC,
        body: payload,
        method: "POST",
      }),
    }),

    mccUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.MMC + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    mccView: builder.query({
      query: (id) => URL.MMC + "/" + id,
    }),

    recommendationList: builder.query({
      query: (parmas) => URL.RECOMMENDATION + parmas,
    }),

    recommendationStatus: builder.query({
      query: (id) => URL.RECOMMENDATION + "/status/" + id,
    }),

    recommendationCreate: builder.mutation({
      query: (payload) => ({
        url: URL.RECOMMENDATION,
        body: payload,
        method: "POST",
      }),
    }),

    recommendationUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.RECOMMENDATION + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    recommendationView: builder.query({
      query: (id) => URL.RECOMMENDATION + "/" + id,
    }),

    recommendationProperties: builder.query({
      query: (id) => URL.RECOMMENDATION + "/properties/" + id,
    }),

    subscriptionCancelRequest: builder.query({
      query: (parmas) => URL.SUBSCRIPTION_CANCEL_REQUESTS + parmas,
    }),

    subscriptionCanceled: builder.query({
      query: (parmas) => URL.SUBSCRIPTION_CANCELED + parmas,
    }),

    cancelSubscription: builder.query({
      query: (parmas) => URL.CANCEL_SUBSCRIPTION + parmas,
    }),

    propertyRecommendations: builder.query({
      query: (parmas) => URL.PROPERTY_RECOMMENDATIONS + parmas,
    }),

    mccPropertiesList: builder.query({
      query: (parmas) => URL.MCC_PROPERTIES + parmas,
    }),

    servicesList: builder.query({
      query: (parmas) => URL.SERVICES + parmas,
    }),

    servicesStatus: builder.query({
      query: (id) => URL.SERVICES + "/status/" + id,
    }),

    servicesCreates: builder.mutation({
      query: (payload) => ({
        url: URL.SERVICES,
        body: payload,
        method: "POST",
      }),
    }),

    serviceUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.SERVICES + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    serviceView: builder.query({
      query: (id) => URL.SERVICES + "/" + id,
    }),

    categoryList: builder.query({
      query: (parmas) => URL.CATEGORIES + parmas,
    }),

    categoryStatus: builder.query({
      query: (id) => URL.CATEGORIES + "/status/" + id,
    }),

    categoryCreateList: builder.query({
      query: () => URL.CATEGORIES + "/create",
    }),

    categoryCreate: builder.mutation({
      query: (payload) => ({
        url: URL.CATEGORIES,
        body: payload,
        method: "POST",
      }),
    }),

    categoryUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.CATEGORIES + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    categoryView: builder.query({
      query: (id) => URL.CATEGORIES + "/" + id,
    }),

    timeSlotList: builder.query({
      query: (parmas) => URL.TIME_SLOT + parmas,
    }),

    timeSlotStatus: builder.query({
      query: (id) => URL.TIME_SLOT + "/status/" + id,
    }),

    timeSlotCreate: builder.mutation({
      query: (payload) => ({
        url: URL.TIME_SLOT,
        body: payload,
        method: "POST",
      }),
    }),

    timeSlotUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.TIME_SLOT + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    timeSlotView: builder.query({
      query: (id) => URL.TIME_SLOT + "/" + id,
    }),

    roomcList: builder.query({
      query: (parmas) => URL.ROOM_CATEGORY_LIST + parmas,
    }),

    roomcStatus: builder.query({
      query: (id) => URL.ROOM_CATEGORY_LIST + "/status/" + id,
    }),

    roomcCreate: builder.mutation({
      query: (payload) => ({
        url: URL.ROOM_CATEGORY_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    roomcUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.ROOM_CATEGORY_LIST + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    roomcView: builder.query({
      query: (id) => URL.ROOM_CATEGORY_LIST + "/" + id,
    }),

    bookingList: builder.query({
      query: (parmas) => URL.BOOKING + parmas,
    }),

    todayEarningList: builder.query({
      query: (parmas) => URL.TODAY_EARNING + parmas,
    }),

    cancelledBookingList: builder.query({
      query: (parmas) => URL.CANCELLED_BOOKING + parmas,
    }),

    tipsList: builder.query({
      query: (parmas) => URL.TIPS + parmas,
    }),

    tipsStatus: builder.query({
      query: (id) => URL.TIP + "/status/" + id,
    }),

    tipsCreate: builder.mutation({
      query: (payload) => ({
        url: URL.TIP + "-add",
        body: payload,
        method: "POST",
      }),
    }),

    tipsUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.TIP + "-update/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    tipsView: builder.query({
      query: (id) => URL.TIPS + "/" + id,
    }),

    tipsDelete: builder.query({
      query: (id) => URL.TIP + "/delete/" + id,
    }),

    userSupportList: builder.query({
      query: (parmas) => URL.SUPPORT + "user" + parmas,
    }),

    userResolveList: builder.query({
      query: (parmas) => URL.RESOLVE + "user" + parmas,
    }),

    ownerSupportList: builder.query({
      query: (parmas) => URL.SUPPORT + "owner" + parmas,
    }),

    ownerResolveList: builder.query({
      query: (parmas) => URL.RESOLVE + "owner" + parmas,
    }),

    receptionistSupportList: builder.query({
      query: (parmas) => URL.SUPPORT + "receptionist" + parmas,
    }),

    receptionistResolveList: builder.query({
      query: (parmas) => URL.RESOLVE + "receptionist" + parmas,
    }),

    supportStatus: builder.mutation({
      query: (payload) => ({
        url: URL.SUPPORT_STATUS,
        body: payload,
        method: "POST",
      }),
    }),

    transactionList: builder.query({
      query: (parmas) => URL.TRANSACTION + parmas,
    }),

    transactionDetails: builder.query({
      query: (id) => URL.TRANSACTION_DETAILS + id,
    }),

    couponsList: builder.query({
      query: (parmas) => URL.COUPONS + "s" + parmas,
    }),

    couponsTransactionList: builder.query({
      query: (parmas) => URL.COUPONS + "-transactions" + parmas,
    }),

    couponsStatus: builder.query({
      query: (id) => URL.COUPONS + "-status/" + id,
    }),

    couponsAdd: builder.mutation({
      query: (payload) => ({
        url: URL.COUPONS + "-add",
        body: payload,
        method: "POST",
      }),
    }),

    couponsView: builder.query({
      query: (id) => URL.COUPONS + "-edit/" + id,
    }),

    couponsEdit: builder.mutation({
      query: ({ payload, id }) => ({
        url: URL.COUPONS + "-update/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    refferalsList: builder.query({
      query: (parmas) => URL.REFFERALS + parmas,
    }),
    refferalsViewList: builder.query({
      query: (parmas) => URL.REFFERALS + parmas,
    }),

    bannerList: builder.query({
      query: (parmas) => URL.BANNER + parmas,
    }),

    bannerStatus: builder.query({
      query: (id) => URL.BANNER + "/status/" + id,
    }),

    bannerCreate: builder.mutation({
      query: (payload) => ({
        url: URL.BANNER,
        body: payload,
        method: "POST",
      }),
    }),

    bannerUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.BANNER + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    bannerView: builder.query({
      query: (id) => URL.BANNER + "/" + id,
    }),

    bannerDelete: builder.mutation({
      query: (payload) => ({
        url: URL.BANNER,
        body: payload,
        method: "POST",
      }),
    }),

    amenityList: builder.query({
      query: (parmas) => URL.AMENTITY + parmas,
    }),

    amenityStatus: builder.query({
      query: (id) => URL.AMENTITY + "/status/" + id,
    }),

    amenityCreate: builder.mutation({
      query: (payload) => ({
        url: URL.AMENTITY,
        body: payload,
        method: "POST",
      }),
    }),

    amenityUpdate: builder.mutation({
      query: ({ id, payload }) => ({
        url: URL.AMENTITY + "/" + id,
        body: payload,
        method: "POST",
      }),
    }),

    amenityView: builder.query({
      query: (id) => URL.AMENTITY + "/" + id,
    }),

    reviewsList: builder.query({
      query: (parmas) => URL.REVIEWS_LIST + parmas,
    }),

    reviewRoomSharingList: builder.query({
      query: (parmas) => URL.ROOM_SHARIG_REVIEWS_LIST + parmas,
    }),

    reviewStatus: builder.query({
      query: (id) => URL.REVIEW_STATUS + id,
    }),

    reviewView: builder.query({
      query: (id) => URL.REVIEW_VIEW + id,
    }),

    bookingDetailsReport: builder.query({
      query: (parmas) => URL.BOOKING_DETAILS_VIEW + parmas,
    }),

    ownerPaymentReport: builder.query({
      query: (parmas) => URL.OWNER_PAYMENT_VIEW + parmas,
    }),

    transactionReport: builder.query({
      query: (parmas) => URL.TRANSACTION_REPORT + parmas,
    }),

    ownerPaymentImport: builder.mutation({
      query: (payload) => ({
        url: URL.OWNER_PAYMENT_IMPORT,
        body: payload,
        method: "POST",
      }),
    }),

    wishlistPropertiesList: builder.query({
      query: (parmas) => URL.WISHLIST_PROPERTIES + parmas,
    }),

    wishlistPropertiesUserList: builder.query({
      query: (parmas) => URL.WISHLIST_PROPERTIES_USERS + parmas,
    }),
  }),
});

export const {
  useLoginMutation,
  useLazyLogoutQuery,
  useLazyDashboardQuery,
  useLazyRoleListQuery,
  useLazyRoleCreateQuery,
  useLazyRoleViewQuery,
  useRoleAddMutation,
  useRoleEditMutation,
  useLazyRoleStatusQuery,
  useLazyAdminListQuery,
  useLazyAdminStatusQuery,
  useLazyAdminViewQuery,
  useAdminAddMutation,
  useAdminEditMutation,
  useLazyAdminRoleQuery,
  useStateAddMutation,
  useStateEditMutation,
  useLazyStateListQuery,
  useLazyStateViewQuery,
  useLazyCityListQuery,
  useLazyCityViewQuery,
  useLazyGetStateQuery,
  useLazyGetCityLocationQuery,
  useCityAddMutation,
  useCityEditMutation,
  useLazyGetlocationQuery,
  useLazyLocationListQuery,
  useLazyLocationViewQuery,
  useLocationAddMutation,
  useLocationEditMutation,
  useLazyGetStateCitiesQuery,
  useLazyUsersListQuery,
  useLazyUserStatusQuery,
  useLazyUserBookingsQuery,
  useLazyUserDetailsQuery,
  useLazyUserWalletTransactionsQuery,
  useLazyBookingDetailsQuery,
  useLazyRequestPropertyListQuery,
  useLazyRequestPropertyStatusQuery,
  useLazyPropertyCreateQuery,
  usePropertyAddMutation,
  useLazyPropertyViewQuery,
  useLazyPropertyListQuery,
  useLazyPropertyStatusQuery,
  useBlockPropertyMutation,
  useLazyPropertyBookingsQuery,
  useLazyPropertyTransactionsQuery,
  useLazyPropertyServiceQuery,
  useLazyPropertyDeleteQuery,
  usePropertyImgUpdateMutation,
  usePropertyUpdateMutation,
  useFoodPackageAddMutation,
  useFoodPackageEditMutation,
  useLazyFoodPackageDeleteQuery,
  useLazyFoodPackageShowQuery,
  useLazyFoodPackageRemoveQuery,
  usePropertyServiceAddMutation,
  usePropertyServiceEditMutation,
  useLazyPropertyServiceViewQuery,
  useLazyServicesCreateQuery,
  useLazyFullBlockListQuery,
  useLazyListPhasesQuery,
  useLazyShowRoomQuery,
  useBlockVillaPhaseMutation,
  useRoomServiceAddMutation,
  useRoomServiceEditMutation,
  useLazyRoomBookingCreateQuery,
  useRoomAddMutation,
  useRoomEditMutation,
  useLazyRoomBookingSlotQuery,
  useEditTimeSlotMutation,
  useAddTimeSlotMutation,
  useLazyDeleteRoomImgQuery,
  useBlockJwDoMutation,
  useLazyShowGetToGetherQuery,
  useLazyListRoomsQuery,
  useBlockRoomsMutation,
  useLazyOwnerAllListQuery,
  useLazyOwnerStatusQuery,
  useLazyOwnerListQuery,
  useLazyOwnerTransactionsListQuery,
  useLazyPropertiesOwnerListQuery,
  useLazyBlockListQuery,
  useLazyListPhasesRoomsQuery,
  useBlockVillaRoomsMutation,
  useUnBlockProperyMutation,
  useUnBlockRoomMutation,
  useOwnerCreateMutation,
  useOwnerEditMutation,
  useLazyReceptionistListQuery,
  useLazyReceptionistStatusQuery,
  useLazyReceptionistViewQuery,
  useLazyReceptionistMasterQuery,
  useLazyOwnerPropertiesListQuery,
  useReceptionistCreateMutation,
  useReceptionistEditMutation,
  useLazyMmcListQuery,
  useLazyMmcStatusQuery,
  useMccCreateMutation,
  useMccUpdateMutation,
  useLazyMccViewQuery,
  useLazyRecommendationListQuery,
  useLazyRecommendationStatusQuery,
  useRecommendationCreateMutation,
  useRecommendationUpdateMutation,
  useLazyRecommendationPropertiesQuery,
  useLazyRecommendationViewQuery,
  useLazySubscriptionCancelRequestQuery,
  useLazyCancelSubscriptionQuery,
  useLazySubscriptionCanceledQuery,
  useLazyPropertyRecommendationsQuery,
  useLazyPropertyShowQuery,
  useLazyMccPropertiesListQuery,
  useLazyServicesListQuery,
  useLazyServicesStatusQuery,
  useServicesCreatesMutation,
  useServiceUpdateMutation,
  useLazyServiceViewQuery,
  useLazyCategoryListQuery,
  useLazyCategoryStatusQuery,
  useLazyCategoryViewQuery,
  useCategoryCreateMutation,
  useCategoryUpdateMutation,
  useLazyCategoryCreateListQuery,
  useLazyTimeSlotListQuery,
  useLazyTimeSlotStatusQuery,
  useLazyTimeSlotViewQuery,
  useTimeSlotCreateMutation,
  useTimeSlotUpdateMutation,
  useLazyRoomcListQuery,
  useLazyRoomcStatusQuery,
  useLazyRoomcViewQuery,
  useRoomcCreateMutation,
  useRoomcUpdateMutation,
  useLazyBookingListQuery,
  useLazyTodayEarningListQuery,
  useLazyCancelledBookingListQuery,
  useLazyTipsListQuery,
  useLazyTipsStatusQuery,
  useLazyTipsViewQuery,
  useTipsCreateMutation,
  useTipsUpdateMutation,
  useLazyTipsDeleteQuery,
  useLazyUserSupportListQuery,
  useLazyUserResolveListQuery,
  useLazyOwnerResolveListQuery,
  useLazyOwnerSupportListQuery,
  useLazyReceptionistResolveListQuery,
  useLazyReceptionistSupportListQuery,
  useSupportStatusMutation,
  useLazyTransactionListQuery,
  useLazyTransactionDetailsQuery,
  useLazyCouponsListQuery,
  useLazyCouponsTransactionListQuery,
  useLazyCouponsStatusQuery,
  useCouponsAddMutation,
  useLazyCouponsViewQuery,
  useCouponsEditMutation,
  useLazyRefferalsListQuery,
  useLazyRefferalsViewListQuery,
  useLazyBannerListQuery,
  useLazyBannerStatusQuery,
  useBannerCreateMutation,
  useBannerUpdateMutation,
  useLazyBannerViewQuery,
  useBannerDeleteMutation,
  useLazyAmenityListQuery,
  useLazyAmenityStatusQuery,
  useLazyAmenityViewQuery,
  useAmenityCreateMutation,
  useAmenityUpdateMutation,
  useLazyReviewsListQuery,
  useLazyReviewRoomSharingListQuery,
  useLazyReviewStatusQuery,
  useLazyReviewViewQuery,
  useLazyBookingDetailsReportQuery,
  useLazyOwnerPaymentReportQuery,
  useLazyTransactionReportQuery,
  useOwnerPaymentImportMutation,
  useLazyWishlistPropertiesListQuery,
  useLazyWishlistPropertiesUserListQuery,
} = api;
